const jobs = [
  ['0', '新手 / 通用'], ['100', '战士'], ['110', '剑客'], ['111', '勇士'], ['112', '英雄'],
  ['120', '准骑士'], ['121', '骑士'], ['122', '圣骑士'], ['130', '枪战士'], ['131', '龙骑士'],
  ['132', '黑骑士'], ['200', '魔法师'], ['210', '火毒法师'], ['211', '火毒巫师'], ['212', '火毒魔导师'],
  ['220', '冰雷法师'], ['221', '冰雷巫师'], ['222', '冰雷魔导师'], ['230', '牧师'], ['231', '祭司'],
  ['232', '主教'], ['300', '弓箭手'], ['310', '猎人'], ['311', '射手'], ['312', '神射手'],
  ['320', '弩弓手'], ['321', '游侠'], ['322', '箭神'], ['400', '飞侠'], ['410', '刺客'],
  ['411', '无影人'], ['412', '隐士'], ['420', '侠客'], ['421', '独行客'], ['422', '侠盗'],
  ['500', '海盗'], ['510', '拳手'], ['511', '斗士'], ['512', '冲锋队长'], ['520', '火枪手'],
  ['521', '大副'], ['522', '船长'], ['1000', '骑士团新手'], ['1100', '魂骑士'], ['1110', '魂骑士 2转'],
  ['1111', '魂骑士 3转'], ['1112', '魂骑士 4转'], ['1200', '炎术士'], ['1210', '炎术士 2转'], ['1211', '炎术士 3转'],
  ['1212', '炎术士 4转'], ['1300', '风灵使者'], ['1310', '风灵使者 2转'], ['1311', '风灵使者 3转'], ['1312', '风灵使者 4转'],
  ['1400', '夜行者'], ['1410', '夜行者 2转'], ['1411', '夜行者 3转'], ['1412', '夜行者 4转'], ['1500', '奇袭者'],
  ['1510', '奇袭者 2转'], ['1511', '奇袭者 3转'], ['1512', '奇袭者 4转'], ['2000', '战神新手'], ['2100', '战神'],
  ['2110', '战神 2转'], ['2111', '战神 3转'], ['2112', '战神 4转'],
] as const satisfies readonly (readonly [string, string])[]

export interface JobIdentity {
  readonly jobKey: string
  readonly rankName: string
  readonly gameName: string
  readonly aliases: readonly string[]
}

const gameNames: Readonly<Record<string, string>> = {
  '0': '新手',
  '210': '法师（火，毒）',
  '220': '法师（冰，雷）',
}

export const jobIdentities: readonly JobIdentity[] = jobs.map(([jobKey, rankName]) => {
  const gameName = gameNames[jobKey] ?? rankName
  return { jobKey, rankName, gameName, aliases: jobKey === '0' ? [rankName, gameName, '通用'] : [rankName, gameName] }
})

const jobByName = new Map<string, JobIdentity>()
const mageByName = new Map<string, JobIdentity>()
for (const job of jobIdentities) {
  for (const alias of job.aliases) {
    jobByName.set(normalizeJobText(alias), job)
    if (job.jobKey === '210' || job.jobKey === '220') mageByName.set(mageAliasKey(alias), job)
  }
}

export function normalizeJobText(value: string): string {
  return value.normalize('NFKC').replace(/\s+/gu, ' ').trim()
}

function mageAliasKey(value: string): string {
  // Only punctuation/spacing may be lost. Every letter must match the full alias.
  return normalizeJobText(value).replace(/[\s(),、]/gu, '')
}

export function resolveJobIdentity(value: string | null | undefined): JobIdentity | null {
  if (!value) return null
  return jobByName.get(normalizeJobText(value)) ?? mageByName.get(mageAliasKey(value)) ?? null
}

/** Shared by OCR parsing and admission; unknown names keep the existing structural rules. */
export function normalizeJobName(text: string): string | null {
  const normalized = normalizeJobText(text)
  const length = [...normalized].length
  if (length < 2 || length > 16) return null
  if (/\d/u.test(normalized) || /^(?:LV|EXP|HP|MP)$/iu.test(normalized.replace(/[\s.]/g, ''))) return null
  const known = resolveJobIdentity(normalized)
  if (known) return known.gameName
  if (!/^[\p{L}\p{M}](?:[\p{L}\p{M} ·•・'’-]{0,14}[\p{L}\p{M}])?$/u.test(normalized)) return null
  return normalized
}
